import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';
import persianJs from 'persianjs'

import { PureComponent, Form, GroupBox } from 'core/components';
import { withLocale } from 'core/decorators';
import { Icon, List, ListInput, Button, CardContent } from 'core/components/Framework7';
import { register, verification } from 'core/module/operations';

import classes from './styles.module.css';

const NumericInput = Form.NumericInput;

class Register extends PureComponent {
  constructor(props) {
    super(props)

    // console.log('register props:', props)
    this.router = this.$f7.views.current && this.$f7.views.current.router

    this.state = {
      step: 1,
      phone: props.phone || '',
      code: props.code || '',
    }
  }

  get data() {
    const { env } = this.props;

    return {
      page: env && env.pages && env.pages.register,
    }
  }

  sendCodeAndCheckPhone() {
    const { phone } = this.state;

    this.$f7.dialog.preloader('در حال ارسال اطلاعات');

    const params = {
      errorHandler: true
    }

    this.props.register({ mobile: phone }, params)
      .then(r => {
        this.$f7.dialog.alert(`کد تأیید به شماره ${phone} ارسال شد`, 'کد تأیید');
        this.setState({ step: 2 })
      })
      .catch(e => {
        // TODO Redirect to corresponding pages
        this.$f7.dialog.alert(`شماره ${phone} در فهرست شماره‌های ثبت شده قرار دارد. لطفا شماره خود را بررسی کرده و در صورت اطمینان وارد سامانه شوید. در صورت فراموشی رمز عبور، اقدام به بازیابی آن کنید.`, 'خطا');
      })
      .finally(r => {
        this.$f7.dialog.close()
      })
  }

  verifyCode() {
    const { phone, code } = this.state;

    this.$f7.dialog.preloader('در حال ارسال اطلاعات');

    const model = {
      code,
      mobile: phone
    }

    const params = {
      errorHandler: true
    }

    this.props.verification(model, params)
      .then(r => {
        // this.props.navigate.navigate('/profile/complete', { props: { navigate: this.props.navigate } })
        this.router && this.router.navigate('/profile/complete')
      })
      .catch(e => {
        this.$f7.dialog.alert('کد وارد شده صحیح نمی باشد', 'خطا');
      })
      .finally(r => {
        this.$f7.dialog.close()
        // console.log('register props:', this.props)

      })
  }

  handlePhone(e) {
    if (!e.target.value || e.target.value == "") {
      this.setState({
        phone: ''
      })

      return
    }

    this.setState({
      phone: persianJs(e.target.value).toEnglishNumber().toString()
    })
  }

  handleCode(e) {
    if (!e.target.value || e.target.value == "") {
      this.setState({
        code: ''
      })

      return
    }

    this.setState({
      code: persianJs(e.target.value).toEnglishNumber().toString()
    })
  }

  handleSubmit() {
    const { step } = this.state;

    switch (step) {
      case 1:
        return this.sendCodeAndCheckPhone();
      case 2:
        return this.verifyCode();
    }
  }

  hasError() {
    const { step, phone, code } = this.state;

    let valid = false

    switch (step) {
      case 1:
        valid = (phone.length == 11 || phone.length == 10)
        break
      case 2:
        valid = (code.length >= 4)
        break
    }

    return !valid
  }

  onSubmit(e) {
    e.preventDefault();
  }

  render() {
    const { step, phone, code } = this.state;

    return (
      <form action="" onSubmit={this.onSubmit} className={classes.container}>
        <div className={`${classes.pagePadding}`}>
          <GroupBox outline title='ثبت نام'>
            <CardContent>
              <List noHairlinesMd>
                <ListInput
                  type="tel"
                  clearButton={step == 1}
                  required
                  validate
                  value={phone}
                  placeholder="شماره تلفن همراه خود را وارد کنید"
                  info={'مانند ۰۹۱۲۳۴۵۶۷۸۹'}
                  errorMessage={'لطفا شماره تلفن همراه خود را وارد کنید'}
                  disabled={step > 1}
                  onInputClear={() => this.setState({ phone: '' })}
                  onChange={this.handlePhone}
                  className={classes.input}
                >
                  <Icon icon="mdi-phone" slot="media" />
                </ListInput>

                {step == 2 &&
                  <ListInput
                    type="number"
                    pattern="\d*"
                    clearButton
                    required
                    validate
                    value={code}
                    placeholder="کد تأیید"
                    info={'کد تأیید ارسال شده به شماره تلفن همراه'}
                    errorMessage={'لطفا کد تأیید ارسال شده به شماره تلفن همراه خود را وارد کنید'}
                    onInputClear={() => this.setState({ code: '' })}
                    onChange={this.handleCode}
                    className={classes.input}
                  >
                    <Icon icon="mdi-lock-open" slot="media" />
                  </ListInput>
                }

              </List>
            </CardContent>
          </GroupBox>
          {this.data.page.description && this.data.page.description.length > 0 &&
            <GroupBox outline title={'توضیحات'}>
              <CardContent>
                {this.data.page.description.map((text, index) => {
                  return <div key={index}>{`- ${text}`}</div>
                })}
              </CardContent>
            </GroupBox>
          }
        </div>

        <Button large fill
          type='submit'
          icon={step == 1 ? 'mdi-cellphone-message' : step == 2 ? 'mdi-phone-check' : false}
          text={step == 1 ? "ارسال کد تأیید" : step == 2 ? "تأیید کد" : "ثبت نام"}
          className={classes.fullWidthButton}
          disabled={this.hasError()}
          onClick={this.handleSubmit}
        />
      </form>
    )
  }
}

export default connect(
  state => ({
    env: state.General.env,
  }),
  {
    register,
    verification
  }
)(withLocale('register')(autobind(Register)))